"use strict";

exports.__esModule = true;
exports.DeviceMetricSubscription = void 0;
var _react = _interopRequireDefault(require("react"));
var _RealtimeConnection = require("../../API/RealtimeConnection");
var _excluded = ["deviceUuid", "metricName", "reportingPeriod"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Subscribes to a metric for a device.
 */
var DeviceMetricSubscription = exports.DeviceMetricSubscription = function DeviceMetricSubscription(_ref) {
  var deviceUuid = _ref.deviceUuid,
    metricName = _ref.metricName,
    reportingPeriod = _ref.reportingPeriod,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_RealtimeConnection.RealtimeDataSubscription, _extends({
    params: ["metric", {
      entity: {
        device: deviceUuid,
        name: metricName,
        period: reportingPeriod
      }
    }]
  }, extra));
};